<template>
    <div :style="[elementStyles, basicContentStyles]">
        <eicon kind="layer" class="eicon-center text-white layer overlay" :style="{'fontSize': Math.max(min_width_height/2, 20) + 'px'}"></eicon>
    </div>
</template>

<script>
    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
                t_layer_not_set: Lang.langGet("Layer not set!"),
            }
        },
        computed: {
            min_width_height: function () {
                return Math.min(this.width, this.height);
            },
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    backgroundImage: "linear-gradient(45deg, #cccccc 25%, transparent 25%, transparent 75%, #cccccc 75%, #cccccc), linear-gradient(45deg, #cccccc 25%, transparent 25%, transparent 75%, #cccccc 75%, #cccccc)",
                    backgroundSize: "4px 4px",
                    backgroundPosition: "0 0, 2px 2px",
                    backgroundRepeat: "unset",
                    opacity: opacity,
                }
            },
        }
    }
</script>
